export function uncapitalize(str: string): string {
  return str.charAt(0).toLowerCase() + str.slice(1);
}

export function shortenString(str: string, len: number): string {
  if (len <= 0 || str?.length <= len) { return str; }
  return str.substring(0, Math.ceil(len / 2)) + '..' + str.substring(str.length - Math.floor(len / 2));
}

export function stringToFloat(str: string): number {
  const raw = str.trim().replace(/\s/g, '');
  const commaIndex = raw.lastIndexOf(',');
  const dotIndex = raw.lastIndexOf('.');

  if (commaIndex >= 0 && dotIndex >= 0) {
    // Use the rightmost separator as decimal mark and treat the other as thousands separator
    return commaIndex > dotIndex
      ? parseFloat(raw.replace(/\./g, '').replace(',', '.'))
      : parseFloat(raw.replace(/,/g, ''));
  }

  return commaIndex >= 0
    ? parseFloat(raw.replace(',', '.'))
    : parseFloat(raw);
}
